import { Component } from '@angular/core';

@Component({
  selector: 'app-new-feature-soon',
  templateUrl: './new-feature-soon.component.html',
  styleUrls: ['./new-feature-soon.component.scss']
})
export class NewFeatureSoonComponent {

}
